import React, { Component } from 'react';
import Header from '../components/header/header';
import TimeInterval from '../components/timeInterval/timeInterval';
import { Table, Button, Input, message, Popconfirm, Select, Pagination, ConfigProvider } from 'antd';
import Loading from '../../components/loading/loading';
import DocumentTitle from 'react-document-title';
import queryString from 'query-string';
import moment from 'moment';
import './baichengUserCensus.less';
import API from '../../../api/api';
import zhCN from 'antd/es/locale/zh_CN';
import baichengLogo from '../../../assets/image/query/baicheng/baichengLogo.png';
class UserCensus extends Component {
    constructor(props) {
        super(props);
        this.chooseDateRange = this.chooseDateRange.bind(this);
        this.clearTime = this.clearTime.bind(this);
    }
    state = {
        data: null,
        apiData: {
            startTime: '',
            endTime: '',
        },
        systemColor:'#7E61C9',
        error: '',
    };
    componentDidMount(){
        this.submitSearch();
    }
    componentWillReceiveProps() {
        this.submitSearch();
    }
    chooseDateRange(value) {
        const { apiData } = this.state;
        apiData.startTime = value.startTime;
        apiData.endTime = value.endTime;
        this.setState({ apiData });
    }
    clearTime() {
        const { apiData } = this.state;
        delete (apiData.startTime);
        delete (apiData.endTime);
        this.setState({ apiData });
    }
    getData = async (param) => {
        let result = await API.baichengOrderConversion(param);
        if (!result) return;
        if (result.status == 1) {
            this.setState({ data: result.data })
            return;
        }
        message.error(result.msg);
    }
    submitSearch() {
        const { apiData } = this.state;
        for (let key in apiData) {
            if (apiData[key] === '')
                delete (apiData[key])
        }
        this.getData(apiData)
    }
    render() {
        if (!this.state.data) {
            return <Loading></Loading>
        }
        const {
            data,
            systemColor
        } = this.state;
        return (
            <DocumentTitle title="“百程俱乐部”用户转化统计">
                <ConfigProvider locale={zhCN}><div className="baichengCensusPane">
                    <Header roleName={'“百程俱乐部”用户转化统计'} systemColor={systemColor} systemLogoUrl={baichengLogo}></Header>
                    <div className="search-condition">
                        {/* 时间选择器 */}
                        <div className="time-tmp" id="time-tmp">
                            <TimeInterval
                                className="timePicker"
                                confirmCallback={this.chooseDateRange}
                                clearTime={this.clearTime}
                            ></TimeInterval>
                        </div>
                        {/* 搜索按钮 */}
                        <div className="search-btn" onClick={this.submitSearch.bind(this)}>搜索</div>
                    </div>
                    <div className="tablePane">
                        <div className="tableBlock">
                            <table className="tableBlock">
                                <tbody>
                                    <tr>
                                        <th>统计字段</th>
                                        <th>统计数值</th>
                                    </tr>
                                    <tr>
                                        <td>填表注册数</td>
                                        <td>{data.tianBiaoCount}</td>
                                    </tr>
                                    <tr>
                                        <td>组局活动注册数</td>
                                        <td>{data.zjZhuceCount}</td>
                                    </tr>
                                    <tr>
                                        <td>抽奖活动注册数</td>
                                        <td>{data.cjZhuceCount}</td>
                                    </tr>
                                    <tr>
                                        <td>总计注册数（去重）</td>
                                        <td>{data.sumUserCount}</td>
                                    </tr></tbody>
                            </table>
                        </div>
                        <div className="tableBlock">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>统计字段</th>
                                        <th>统计数值</th>
                                    </tr>
                                    <tr>
                                        <td>出签注册数</td>
                                        <td>{data.chuqianZhuceCount}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* <div className="tipInfo">
                                注：<br></br>
                                组局活动ID：232<br></br>
                                抽奖活动ID：3334<br></br>
                            </div> */}
                        </div>
                    </div>
                    <div className="middleLine"></div>
                    <div className="tablePane">
                        <div className="tableBlock">
                            <table className="tableBlock">
                                <tbody>
                                    <tr>
                                        <th>抽奖活动3334</th>
                                        <th>统计数值</th>
                                    </tr>
                                    <tr>
                                        <td>活动参与人数</td>
                                        <td>{data.cjAndPassUserCount}</td>
                                    </tr>
                                    <tr>
                                        <td>活动注册人数</td>
                                        <td>{data.cjZhuceCount}</td>
                                    </tr>
                                    <tr>
                                        <td>抽奖人数</td>
                                        <td>{data.cjAndClickStart}</td>
                                    </tr>
                                    </tbody>
                            </table>
                        </div>
                        <div className="tableBlock">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>组局活动232</th>
                                        <th>统计数值</th>
                                    </tr>
                                    <tr>
                                        <td>验证手机号人数</td>
                                        <td>{data.zjAndPassUserCount}</td>
                                    </tr>
                                    <tr>
                                        <td>验证注册人数</td>
                                        <td>{data.zjAndInUser}</td>
                                    </tr>
                                    <tr>
                                        <td>发起/报名局人数</td>
                                        <td>{data.zjZhuceCount}</td>
                                    </tr>
                                    <tr>
                                        <td>发起局数</td>
                                        <td>{data.zjAndStart}</td>
                                    </tr>
                                    <tr>
                                        <td>完成局数</td>
                                        <td>{data.zjAndComplete}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default UserCensus;